var leveljs = require('level-js');
var levelup = require('levelup');
var fs = require('level-filesystem');

var db = levelup('level-filesystem', {db:leveljs});
module.exports = fs(db);


//////////////////
// WEBPACK FOOTER
// ./node_modules/browserify-fs/index.js
// module id = 20
// module chunks = 0